import { DevHubTextField } from '@devxdiscover/devhub-ui';

import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder';

/**
 * The input props that can be specified under `ui:options` for the
 * `FormContextFieldValue` field extension.
 *
 * @public
 */
export interface FormContextFieldValueUiOptions {
  fieldName?: string;
  pattern?: string;
}

/**
 * The underlying component that is rendered in the form for the `FormContextFieldValue`
 * field extension. This allows for the specification of a value from elsewhere in the
 * form context.
 * @param props - The properties passed to the component.
 */
export const FormContextFieldValue = (
  props: FieldExtensionComponentProps<string, FormContextFieldValueUiOptions>,
) => {
  const {
    onChange,
    schema: { title = 'Input', description = '' },
    required,
    uiSchema,
    rawErrors,
    formData,
    idSchema,
    formContext,
  } = props;

  const fieldName: string =
    uiSchema['ui:options']?.fieldName ?? '_unspecified_';
  const formatPattern: string = uiSchema['ui:options']?.pattern ?? '{0}';

  function format(pattern: string, ...args: string[]) {
    return pattern.replace(/{(\d+)}/g, (match, number) =>
      typeof args[number] !== 'undefined' ? args[number] : match,
    );
  }

  return (
    <DevHubTextField
      id={idSchema?.$id}
      label={title}
      helperText={description}
      required={required}
      value={
        formData ??
        format(formatPattern, formContext?.formData?.[fieldName]) ??
        ''
      }
      onChange={({ target: { value } }: { target: { value: any } }) =>
        onChange(value)
      }
      margin="none"
      error={rawErrors?.length > 0 && !formData}
    />
  );
};
